module.exports = __webpack_public_path__ + "static/media/cap-partner-card.2ba494b9.png";